import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const XIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 24, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        id="Icon"
        d="M6 18L18 6M6 6L18 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

XIcon.displayName = 'XIcon'
